export const initialMapState = {
	longitude: 10,
	latitude: 56,
	zoom: 1.5,
};

export const mapStyles = [
	{ id: "standard", label: "Standard", url: "mapbox://styles/mapbox/standard" },
	{ id: "streets", label: "Streets", url: "mapbox://styles/mapbox/streets-v12" },
	{ id: "satellite", label: "Satellite", url: "mapbox://styles/mapbox/satellite-streets-v12" },
	{ id: "outdoors", label: "Nature", url: "mapbox://styles/mapbox/outdoors-v12" },
	{ id: "light", label: "Light", url: "mapbox://styles/mapbox/light-v11" },
	{ id: "dark", label: "Dark", url: "mapbox://styles/mapbox/dark-v11" },
];
